import { Brand, createBranded } from '@deltasierra/type-utilities';
import { ClientId } from '../client/ClientId';
import { FullAuditable, HasId } from '../common/model/traits';
import { PathBuilder, ApiRoute, HttpMethod } from '../common/api/routes';
import { Upload, UploadId } from '../upload';
import { LocationCategoryGroupId } from './LocationCategoryGroup';

export interface LocationCategoryOption extends HasId<LocationCategoryOptionId>, FullAuditable {
    clientId: ClientId;
    groupId: LocationCategoryGroupId;
    label: string;
    logo?: Upload;
    logoId?: UploadId;
}

export type LocationCategoryOptionView = Pick<LocationCategoryOption, 'clientId' | 'groupId' | 'id' | 'label'>;

export interface CreateLocationCategoryOptionBody {
    label: string;
}

export interface LocationCategoryOptionCollectionParams {
    clientId: ClientId;
    groupId: LocationCategoryGroupId;
}

const LOCATION_CATEGORY_OPTION_COLLECTION_API_ROOT = <T extends LocationCategoryOptionCollectionParams>(
    path: PathBuilder<T>,
) => path.literal('clients').param('clientId').literal('locationCategories').param('groupId').literal('options');
export const LocationCategoryOptionApi = {
    createLocationCategoryOption: new ApiRoute<
        LocationCategoryOption,
        LocationCategoryOptionCollectionParams,
        CreateLocationCategoryOptionBody,
        void
    >(HttpMethod.Post, LOCATION_CATEGORY_OPTION_COLLECTION_API_ROOT),
    deleteLocationCategoryOption: new ApiRoute<
        void,
        LocationCategoryOptionCollectionParams & { optionId: LocationCategoryOptionId },
        void,
        void
    >(HttpMethod.Post, path => LOCATION_CATEGORY_OPTION_COLLECTION_API_ROOT(path).param('optionId')),
};

export type LocationCategoryOptionId = Brand<number, 'LocationCategoryOptionId'>;
export const LocationCategoryOptionId = createBranded<LocationCategoryOptionId>();
